import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  styleUrls: ['../../global-styles.less', './tellent-account-confirmation.component.less'],
  templateUrl: './tellent-account-confirmation.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class TellentAccountConfirmationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentAccountConfirmationTemplateData>;
}

export type TellentAccountConfirmationTemplateData = {
  header: string;
  subheader: string;
  body: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
  primary_cta: {
    href: string;
    label: string;
  };
};

export const TellentAccountConfirmationTemplateMocks: TellentAccountConfirmationTemplateData[] = [
  {
    header: 'Activate your account',
    subheader: 'We’re thrilled to have you on board! Activate your account with just a click.',
    body: 'If you didn’t create an account, please ignore this email.',
    footer: {
      text: 'Need help?',
      href: 'https://auth.tellent.com/?intercom_open=true',
      label: 'Contact us',
      target: '_blank',
    },
    primary_cta: {
      href: 'https://tellent.com',
      label: 'Activate account',
    },
  },
];
